export const enum ReferenceUnit {
    KWP = 'kWp',
    UNIT = "unit",
    SUBTOTAL = "subtotal"
}

export const enum ExtraChargeType {
    PERCENT = "percent",
    EURO = "euro"
}